import * as React from "react";

function SvgIcXCircle(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 12a6 6 0 11-12 0 6 6 0 0112 0zm2 0a8 8 0 11-16 0 8 8 0 0116 0zm-9.293-2.707a1 1 0 00-1.414 1.414L10.586 12l-1.293 1.293a1 1 0 101.414 1.414L12 13.414l1.293 1.293a1 1 0 001.414-1.414L13.414 12l1.293-1.293a1 1 0 00-1.414-1.414L12 10.586l-1.293-1.293z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgIcXCircle;
